import { name } from './constants'

export const getState = (state) => state[name]

export const getAccounts = (state) => state[name].accounts ?? {}

export const getActiveUserId = (state) => state[name].accounts?.activeUserId

export const getAccount = (state) =>
  state[name].accounts?.[state[name].accounts?.activeUserId] ?? {}

export const getAccessToken = (state) => getAccount(state).accessToken ?? ''

export const getFeatureHint = (state) => state[name].featureHint

export const getHasOpenedAnswerModal = (state) =>
  state[name].hasOpenedAnswerModal

export const getHiddenAnswerIds = (state) =>
  getAccount(state).hiddenAnswerIds ?? []

export const getIsLoggedIn = (state) => Boolean(getAccessToken(state))

export const getShouldContactsBeUploaded = (state) =>
  getAccount(state).shouldContactsBeUploaded ?? false
